/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { AfnoDetails, AfnoEntity } from "~/features/promoTools/types";

interface TransformAfnoEntity {
  toAfnoDetails: (data: AfnoEntity) => AfnoDetails;
}

const transformAfnoEntity: TransformAfnoEntity = {
  toAfnoDetails: (data) => ({
    id: data.id,
    trackingId: data.trackingid,
    label: data.label,
    mapped: data.mapped,
  }),
};

export default transformAfnoEntity;
